import { useEffect, useRef, useState } from 'react';
import '../styles/TheComeback.css';

const STATS = [
  { id: 'tvl', prefix: '$', target: 139550379, decimals: 0, label: 'TVL' },
  { id: 'xrp', prefix: '', suffix: '%', target: 3, decimals: 0, label: 'XRP Vault APY' },
  { id: 'rlusd', prefix: '', suffix: '%', target: 7, decimals: 0, label: 'RLUSD Vault APY' },
];

function formatNumber(value, decimals) {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

function useCountUp(target, isVisible, duration = 1800) {
  const [value, setValue] = useState(0);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!isVisible || startedRef.current) return;
    startedRef.current = true;

    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out for a natural deceleration into the final number
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(target * eased);
      if (progress < 1) requestAnimationFrame(tick);
      else setValue(target);
    }

    requestAnimationFrame(tick);
  }, [isVisible, target, duration]);

  return value;
}

function StatCard({ stat, isVisible }) {
  const value = useCountUp(stat.target, isVisible);
  return (
    <div className="comeback__card">
      <div className="comeback__value">
        {stat.prefix}
        {formatNumber(Math.round(value), stat.decimals)}
        {stat.suffix}
      </div>
      <div className="comeback__label">{stat.label}</div>
    </div>
  );
}

export default function TheComeback({ zIndex }) {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="comeback" style={{ zIndex }} ref={sectionRef}>
      <div className="comeback__topbar">
        <span className="comeback__brand">Doppler.finance</span>
        <span className="comeback__pill">
          <span className="comeback__pill-brace">{'{'}</span>
          Doppler in Numbers
          <span className="comeback__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="comeback__heading">
        <span className="comeback__line">
          <span className="comeback__muted">Built on</span> <span className="comeback__bold">Numbers,</span>
        </span>
        <span className="comeback__line">
          <span className="comeback__muted">Driven by</span> <span className="comeback__bold">Users</span>
        </span>
      </h2>

      <div className="comeback__grid">
        {STATS.map((stat) => (
          <StatCard key={stat.id} stat={stat} isVisible={isVisible} />
        ))}
      </div>
    </section>
  );
}